import firebase from "@firebase/app";
import "@firebase/auth";
import "@firebase/firestore";
import "@firebase/storage";

const config =  {
    apiKey: "AIzaSyBLKMU6plSAWWPtJrf_Fpbf6jnvA80grj0",
    authDomain: "dream-app-6d671.firebaseapp.com",
    databaseURL: "https://dream-app-6d671.firebaseio.com",
    projectId: "dream-app-6d671",
    storageBucket: "",
    messagingSenderId: "1052949036603",
    appId: "1:1052949036603:web:12ac718bf790475e"
  };
  // Initialize Firebase
  export default {
    init() {
        firebase.initializeApp(config);
    }
}